export const chainConfigs = {
  1: {
    FACTORY_OWNER: "0xDB392f4391462d60B8B4413ef72018Ab595Af9D0",
    MINT_FEE_RECIPIENT: "0xd1d1D4e36117aB794ec5d4c78cBD3a8904E691D0",
    PROTOCOL_REWARDS: "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B",
  },
  10: {
    FACTORY_OWNER: "0x4c7f7b6067fac9a737ecf2ca1a733fc85dd65a2b",
    MINT_FEE_RECIPIENT: "0x7A810DCd0f8d83B20212326813Db6EF7E9FD030c",
    PROTOCOL_REWARDS: "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B",
  },
  999: {
    FACTORY_OWNER: "0xE84DBB2B25F761751231a9D0DAfbdD4dC3aa8252",
    MINT_FEE_RECIPIENT: "0xE84DBB2B25F761751231a9D0DAfbdD4dC3aa8252",
    PROTOCOL_REWARDS: "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B",
  },
  8453: {
    FACTORY_OWNER: "0x004d6611884B4A661749B64b2ADc78505c3e1AB3",
    MINT_FEE_RECIPIENT: "0x7bf90111Ad7C22bec9E9dFf8A01A44713CC1b1B6",
    PROTOCOL_REWARDS: "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B",
  },
  42161: {
    FACTORY_OWNER: "0xF7DafC329C93D84267c0E7B146C0bD68807f6A03",
    MINT_FEE_RECIPIENT: "0x10Fb02A68C3EA8bD439A6f515dcE07CC049f5c94",
    PROTOCOL_REWARDS: "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B",
  },
  81457: {
    FACTORY_OWNER: "0x5b297B1b87f8De28C9fA7AFe183Db9F9e6295523",
    MINT_FEE_RECIPIENT: "0x72E6394056f9152D3a41e5A25De383c191D16134",
    PROTOCOL_REWARDS: "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B",
  },
  84532: {
    FACTORY_OWNER: "0x5F14C23983c9e0840Dc60dA880349622f0785420",
    MINT_FEE_RECIPIENT: "0x5F14C23983c9e0840Dc60dA880349622f0785420",
    PROTOCOL_REWARDS: "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B",
  },
  421614: {
    FACTORY_OWNER: "0x256537b56007b32BabEB44E868EC8AA5cBF03D30",
    MINT_FEE_RECIPIENT: "0x256537b56007b32BabEB44E868EC8AA5cBF03D30",
    PROTOCOL_REWARDS: "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B",
  },
  7777777: {
    FACTORY_OWNER: "0xdEA20c96253dc2d64897D2b8d27A8d935dE74955",
    MINT_FEE_RECIPIENT: "0xEcfc2ee50409E459c554a2b0376F882Ce916D853",
    PROTOCOL_REWARDS: "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B",
  },
  11155111: {
    FACTORY_OWNER: "0xCE9F2e8EaFa11637F8A1CB60AE8AaC601Ae30f2D",
    MINT_FEE_RECIPIENT: "0xCE9F2e8EaFa11637F8A1CB60AE8AaC601Ae30f2D",
    PROTOCOL_REWARDS: "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B",
  },
  168587773: {
    FACTORY_OWNER: "0x8cF22F26d528B09b3cc54b7ff956630Bf741b773",
    MINT_FEE_RECIPIENT: "0x8cF22F26d528B09b3cc54b7ff956630Bf741b773",
    PROTOCOL_REWARDS: "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B",
  },
  999999999: {
    FACTORY_OWNER: "0xdae22ce69Afcb7f4bc37D32E267645722949DE0E",
    MINT_FEE_RECIPIENT: "0xdae22ce69Afcb7f4bc37D32E267645722949DE0E",
    PROTOCOL_REWARDS: "0x7777777F279eba3d3Ad8F4E708545291A6fDBA8B",
  },
};
export const addresses = {
  1: {
    CONTRACT_1155_IMPL: "0xAeAA622E522130676A8d5a4D04e28aC9Afb84536",
    CONTRACT_1155_IMPL_VERSION: "2.9.0",
    ERC20_MINTER: "0x777777E8850d8D6d98De2B5f64fae401F96eFF31",
    FACTORY_IMPL: "0x8f5B2dd6160D96B48a35F0619BC32b4b997cA37F",
    FACTORY_PROXY: "0x777777C338d93e2C7adf08D102d45CA7CC4Ed021",
    FIXED_PRICE_SALE_STRATEGY: "0x04E2516A2c207E84a1839755675dfd8eF6302F0a",
    MERKLE_MINT_SALE_STRATEGY: "0xf48172CA3B6068B20eE4917Eb27b5472f1f272C7",
    PREMINTER_IMPL: "0xD754417BDABFCc3a3997B9A15E9F6922a8131Ac1",
    PREMINTER_PROXY: "0x7777773606e7e46C8Ba8B98C08f5cD218e31d340",
    REDEEM_MINTER_FACTORY: "0x78964965cF77850224513a367f899435C5B69174",
    UPGRADE_GATE: "0xbC50029836A59A4E5e1Bb8988272F46ebA0F9900",
    timestamp: 1713899416,
  },
  10: {
    CONTRACT_1155_IMPL: "0xd43f38e67beb199fd6594cCe4Bed31510414e6ab",
    CONTRACT_1155_IMPL_VERSION: "2.10.1",
    ERC20_MINTER: "0x777777E8850d8D6d98De2B5f64fae401F96eFF31",
    FACTORY_IMPL: "0x6A864E792029843A47f584293E2cAB8a86B9c533",
    FACTORY_PROXY: "0x777777C338d93e2C7adf08D102d45CA7CC4Ed021",
    FIXED_PRICE_SALE_STRATEGY: "0x3678862f04290E565cCA2EF163BAeb92Bb76790C",
    MERKLE_MINT_SALE_STRATEGY: "0x899ce31dF6C6Af81203AcAaD285bF539234eF4b8",
    PREMINTER_IMPL: "0xD8f6cf234eE4B689099677Bd94FbA0b1E005181d",
    PREMINTER_PROXY: "0x7777773606e7e46C8Ba8B98C08f5cD218e31d340",
    REDEEM_MINTER_FACTORY: "0x1B28A04b7eB7b93f920ddF2021aa3fAE065395f2",
    UPGRADE_GATE: "0xbC50029836A59A4E5e1Bb8988272F46ebA0F9900",
    timestamp: 1717194758,
  },
  999: {
    CONTRACT_1155_IMPL: "0x2022AdEF470DA3543a19fac8c9be80618112704D",
    CONTRACT_1155_IMPL_VERSION: "2.7.0",
    FACTORY_IMPL: "0x4b0365Ec68C2D92Af2Fa56f120095F0859142Eff",
    FACTORY_PROXY: "0x777777C338d93e2C7adf08D102d45CA7CC4Ed021",
    FIXED_PRICE_SALE_STRATEGY: "0x04E2516A2c207E84a1839755675dfd8eF6302F0a",
    MERKLE_MINT_SALE_STRATEGY: "0xf48172CA3B6068B20eE4917Eb27b5472f1f272C7",
    PREMINTER_IMPL: "0x795Efc066f89DFB03048dDd0598F2D8521c99Df6",
    PREMINTER_PROXY: "0x7777773606e7e46C8Ba8B98C08f5cD218e31d340",
    REDEEM_MINTER_FACTORY: "0x78964965cF77850224513a367f899435C5B69174",
    UPGRADE_GATE: "0x0000000000000000000000000000000000000000",
    timestamp: 1704399834,
  },
  8453: {
    CONTRACT_1155_IMPL: "0x1Eb7Bf3a08784D7cB08CC2AE1448012C0c02bDa2",
    CONTRACT_1155_IMPL_VERSION: "2.10.1",
    ERC20_MINTER: "0x777777E8850d8D6d98De2B5f64fae401F96eFF31",
    FACTORY_IMPL: "0x961b527B5E298569dbD7B1d90630cC515Eb17A4A",
    FACTORY_PROXY: "0x777777C338d93e2C7adf08D102d45CA7CC4Ed021",
    FIXED_PRICE_SALE_STRATEGY: "0x04E2516A2c207E84a1839755675dfd8eF6302F0a",
    MERKLE_MINT_SALE_STRATEGY: "0xf48172CA3B6068B20eE4917Eb27b5472f1f272C7",
    PREMINTER_IMPL: "0xD8f6cf234eE4B689099677Bd94FbA0b1E005181d",
    PREMINTER_PROXY: "0x7777773606e7e46C8Ba8B98C08f5cD218e31d340",
    REDEEM_MINTER_FACTORY: "0x78964965cF77850224513a367f899435C5B69174",
    UPGRADE_GATE: "0xbC50029836A59A4E5e1Bb8988272F46ebA0F9900",
    timestamp: 1717194106,
  },
  42161: {
    CONTRACT_1155_IMPL: "0xf4bf58F869c42d99d7F7AC3868B606239a634526",
    CONTRACT_1155_IMPL_VERSION: "2.10.1",
    ERC20_MINTER: "0x777777E8850d8D6d98De2B5f64fae401F96eFF31",
    FACTORY_IMPL: "0x584BDE6B1442Aa6C572368D206Fe656c01FF1f1F",
    FACTORY_PROXY: "0x777777C338d93e2C7adf08D102d45CA7CC4Ed021",
    FIXED_PRICE_SALE_STRATEGY: "0x1Cd1C1f3b8B779B50Db23155F2Cb244FCcA06B21",
    MERKLE_MINT_SALE_STRATEGY: "0xe770E6f19aecF8ef3145A50087999b5556aB3610",
    PREMINTER_IMPL: "0xD8f6cf234eE4B689099677Bd94FbA0b1E005181d",
    PREMINTER_PROXY: "0x7777773606e7e46C8Ba8B98C08f5cD218e31d340",
    REDEEM_MINTER_FACTORY: "0x69bB4A24EBD8b1B87AF4538E0Ca3075b7E398c3D",
    UPGRADE_GATE: "0xbC50029836A59A4E5e1Bb8988272F46ebA0F9900",
    timestamp: 1717194346,
  },
  81457: {
    CONTRACT_1155_IMPL: "0x370A413874Bde3F40028A3E9BBFC4cA19666F94D",
    CONTRACT_1155_IMPL_VERSION: "2.10.1",
    ERC20_MINTER: "0x777777E8850d8D6d98De2B5f64fae401F96eFF31",
    FACTORY_IMPL: "0xf4bf58F869c42d99d7F7AC3868B606239a634526",
    FACTORY_PROXY: "0x777777C338d93e2C7adf08D102d45CA7CC4Ed021",
    FIXED_PRICE_SALE_STRATEGY: "0x3EB144aee170BF62FdA1536e38aF51f08e34A5D0",
    MERKLE_MINT_SALE_STRATEGY: "0xB9C997FcC46a27331CC986cc2416ee99C1d506c3",
    PREMINTER_IMPL: "0xD8f6cf234eE4B689099677Bd94FbA0b1E005181d",
    PREMINTER_PROXY: "0x7777773606e7e46C8Ba8B98C08f5cD218e31d340",
    REDEEM_MINTER_FACTORY: "0x7A0dE1B1f5420Df5D946878fBe2cF109011BE614",
    UPGRADE_GATE: "0xbC50029836A59A4E5e1Bb8988272F46ebA0F9900",
    timestamp: 1717194549,
  },
  84532: {
    CONTRACT_1155_IMPL: "0x0ef82DaB14798E63F1B99479Ba689e3f6A6fEb6C",
    CONTRACT_1155_IMPL_VERSION: "2.10.1",
    ERC20_MINTER: "0x777777E8850d8D6d98De2B5f64fae401F96eFF31",
    FACTORY_IMPL: "0x97eb05B8db496B12244BCcf17CF377d00a99b67a",
    FACTORY_PROXY: "0x777777C338d93e2C7adf08D102d45CA7CC4Ed021",
    FIXED_PRICE_SALE_STRATEGY: "0xd34872BE0cdb6b09d45FCa067B07f04a1A9aE1aE",
    MERKLE_MINT_SALE_STRATEGY: "0x3E8524770adD176bE381a0529E09f1c6c3502A5a",
    PREMINTER_IMPL: "0xD8f6cf234eE4B689099677Bd94FbA0b1E005181d",
    PREMINTER_PROXY: "0x7777773606e7e46C8Ba8B98C08f5cD218e31d340",
    REDEEM_MINTER_FACTORY: "0x805E0a08dE70f85C01F7848370d5e3fc08aAd0ea",
    UPGRADE_GATE: "0xbC50029836A59A4E5e1Bb8988272F46ebA0F9900",
    timestamp: 1717189193,
  },
  421614: {
    CONTRACT_1155_IMPL: "0x55B53DBE22859d538E3b44DD06C9FAE292409E3c",
    CONTRACT_1155_IMPL_VERSION: "2.10.1",
    ERC20_MINTER: "0x777777E8850d8D6d98De2B5f64fae401F96eFF31",
    FACTORY_IMPL: "0xAF5A4F6F6640734d7D000321Bb27De40D4Ae91f6",
    FACTORY_PROXY: "0x777777C338d93e2C7adf08D102d45CA7CC4Ed021",
    FIXED_PRICE_SALE_STRATEGY: "0x1Cd1C1f3b8B779B50Db23155F2Cb244FCcA06B21",
    MERKLE_MINT_SALE_STRATEGY: "0xe770E6f19aecF8ef3145A50087999b5556aB3610",
    PREMINTER_IMPL: "0xD8f6cf234eE4B689099677Bd94FbA0b1E005181d",
    PREMINTER_PROXY: "0x7777773606e7e46C8Ba8B98C08f5cD218e31d340",
    REDEEM_MINTER_FACTORY: "0x69bB4A24EBD8b1B87AF4538E0Ca3075b7E398c3D",
    UPGRADE_GATE: "0xbC50029836A59A4E5e1Bb8988272F46ebA0F9900",
    timestamp: 1717195052,
  },
  7777777: {
    CONTRACT_1155_IMPL: "0xA0CFBEA2fe941EaE373aEB3359b0171f3F194c35",
    CONTRACT_1155_IMPL_VERSION: "2.10.1",
    ERC20_MINTER: "0x777777E8850d8D6d98De2B5f64fae401F96eFF31",
    FACTORY_IMPL: "0xDAeF162cfF8Abd646190Fe02E70B2956304C552c",
    FACTORY_PROXY: "0x777777C338d93e2C7adf08D102d45CA7CC4Ed021",
    FIXED_PRICE_SALE_STRATEGY: "0x04E2516A2c207E84a1839755675dfd8eF6302F0a",
    MERKLE_MINT_SALE_STRATEGY: "0xf48172CA3B6068B20eE4917Eb27b5472f1f272C7",
    PREMINTER_IMPL: "0xD8f6cf234eE4B689099677Bd94FbA0b1E005181d",
    PREMINTER_PROXY: "0x7777773606e7e46C8Ba8B98C08f5cD218e31d340",
    REDEEM_MINTER_FACTORY: "0x78964965cF77850224513a367f899435C5B69174",
    UPGRADE_GATE: "0xbC50029836A59A4E5e1Bb8988272F46ebA0F9900",
    timestamp: 1717181333,
  },
  11155111: {
    CONTRACT_1155_IMPL: "0xFc40F9BFE1289F27F89BAEfb4DB97CC2D8eF6a38",
    CONTRACT_1155_IMPL_VERSION: "2.10.1",
    ERC20_MINTER: "0x777777E8850d8D6d98De2B5f64fae401F96eFF31",
    FACTORY_IMPL: "0xC7598f8eAA1455f5b2B3f206A9af55B2BA248e3E",
    FACTORY_PROXY: "0x777777C338d93e2C7adf08D102d45CA7CC4Ed021",
    FIXED_PRICE_SALE_STRATEGY: "0x1Cd1C1f3b8B779B50Db23155F2Cb244FCcA06B21",
    MERKLE_MINT_SALE_STRATEGY: "0xe770E6f19aecF8ef3145A50087999b5556aB3610",
    PREMINTER_IMPL: "0xD8f6cf234eE4B689099677Bd94FbA0b1E005181d",
    PREMINTER_PROXY: "0x7777773606e7e46C8Ba8B98C08f5cD218e31d340",
    REDEEM_MINTER_FACTORY: "0x69bB4A24EBD8b1B87AF4538E0Ca3075b7E398c3D",
    UPGRADE_GATE: "0xbC50029836A59A4E5e1Bb8988272F46ebA0F9900",
    timestamp: 1717195426,
  },
  168587773: {
    CONTRACT_1155_IMPL: "0x437A762fc2a8f898Aa7a2575Be21c41753DC4797",
    CONTRACT_1155_IMPL_VERSION: "2.7.1",
    FACTORY_IMPL: "0xF82286760a953D2Bad7D6F2F0da458Ac20f955D3",
    FACTORY_PROXY: "0x777777C338d93e2C7adf08D102d45CA7CC4Ed021",
    FIXED_PRICE_SALE_STRATEGY: "0x3EB144aee170BF62FdA1536e38aF51f08e34A5D0",
    MERKLE_MINT_SALE_STRATEGY: "0xB9C997FcC46a27331CC986cc2416ee99C1d506c3",
    PREMINTER_IMPL: "0xe3150ab94e3730D4B157ffD31Ad042323E122b4C",
    PREMINTER_PROXY: "0x7777773606e7e46C8Ba8B98C08f5cD218e31d340",
    REDEEM_MINTER_FACTORY: "0x7A0dE1B1f5420Df5D946878fBe2cF109011BE614",
    UPGRADE_GATE: "0xbC50029836A59A4E5e1Bb8988272F46ebA0F9900",
    timestamp: 1709234007,
  },
  999999999: {
    CONTRACT_1155_IMPL: "0x1120b10c14d38C85B610292170a784784ED9658E",
    CONTRACT_1155_IMPL_VERSION: "2.10.1",
    ERC20_MINTER: "0x8Ec7f068A77fa5FC1925110f82381374BA054Ff2",
    FACTORY_IMPL: "0x74Fc9A34AebAc1D78Aad0C85FAfcDAbD972FC1B0",
    FACTORY_PROXY: "0x777777C338d93e2C7adf08D102d45CA7CC4Ed021",
    FIXED_PRICE_SALE_STRATEGY: "0x6d28164C3CE04A190D5F9f0f8881fc807EAD975A",
    MERKLE_MINT_SALE_STRATEGY: "0x5e5fD4b758076BAD940db0284b711A67E8a3B88c",
    PREMINTER_IMPL: "0xD8f6cf234eE4B689099677Bd94FbA0b1E005181d",
    PREMINTER_PROXY: "0x7777773606e7e46C8Ba8B98C08f5cD218e31d340",
    REDEEM_MINTER_FACTORY: "0x25cFb6dd9cDE8425e781d6718a29Ccbca3F038d6",
    UPGRADE_GATE: "0x0000000000000000000000000000000000000000",
    timestamp: 1717181506,
  },
};
